<template>
  <div class="container">
    <div class="container_service">
      <span class="service_title">我们的服务</span>
      <div class="service_Steering">
        <img src="../../assets/image/service/Steering .png" />
        <span>our service</span>
        <img src="../../assets/image/service/Steering .png" />
      </div>
    </div>
    <div class="container_Image w">
      <div class="waper_left" @click="dialogVisible = true">
        <!-- 检车家 -->
        <img src="../../assets/image/service/Carhouse.png" />
      </div>
      <div class="waper_center">
        <!--检车 淘车  -->
        <div class="waper_Vehicle"  @click="dialogVisible = true">
          <img src="../../assets/image/service/Vehicle.png" class="left" />
          <div class="Vehicle">检车</div>
        </div>
        <div class="waper_Scouringcar" @click="dialogVisible = true">
          <img src="../../assets/image/service/Scouringcar.png" />
          <div class="Scouringcar">淘车</div>
        </div>
      </div>
      <div class="waper_right">
        <!-- 陪买 -->
        <div class="waper_Accompany" @click="dialogVisible = true">
          <img src="../../assets/image/service/Accompany.png" />
          <div class="Accompany">陪买</div>
        </div>

        <div class="waper_right_b">
          <!-- 整备，提档过户 -->

          <div class="waper_Preparation"  @click="dialogVisible = true">
            <img src="../../assets/image/service/Preparation.png" />
            <div class="Preparation">整备</div>
          </div>

          <div class="waper_Transfer"  @click="dialogVisible = true">
            <img src="../../assets/image/service/Transfer.png" />
            <div class="Transfer">提档过户</div>
          </div>
        </div>
      </div>
    </div>
    <div class="container_advantage">
      <div class="advantage_img">
        <div class="advantage_b">
          <img src="../../assets/image/advantage/beijing.png" />
        </div>
        <div class="advantage_positi">
          <span>我们的优势</span>
          <div class="our">our advantages</div>
        </div>
        <div class="advantage_details">
          <div class="advantage_Five_posiaiton">
            <div class="advantage_Five">
              <div class="advantage_major">
                <img src="../../assets/image/advantage/major.png" />
                <div class="first_level_title">专业规范</div>
                <div class="two_level_title">Professional norms</div>
                <div class="three_level_title">车辆检测9大项361小项</div>
              </div>
              <div class="advantage_objective">
                <img src="../../assets/image/advantage/objective.png" />
                <div class="first_level_title">客观中立</div>
                <div class="two_level_title">objective neutrality</div>
                <div class="three_level_title">不卖车 不推荐、不参与交易</div>
              </div>
              <div class="advantage_industry">
                <img src="../../assets/image/advantage/industry.png" />
                <div class="first_level_title">行业领先</div>
                <div class="two_level_title">Industry leading</div>
                <div class="three_level_title">百万用户的选择</div>
              </div>
              <div class="advantage_Intelligence">
                <img src="../../assets/image/advantage/Intelligence.png" />
                <div class="first_level_title">智能大数据</div>
                <div class="two_level_title">Intelligent big data</div>
                <div class="three_level_title">车辆维保、车辆出险 车辆交易大数据查询</div>
              </div>
              <div class="advantage_Quality">
                <img src="../../assets/image/advantage/Quality.png" />
                <div class="first_level_title">放心保质</div>
                <div class="two_level_title">quality assurance</div>
                <div class="three_level_title">车辆错检漏检 赔偿十倍检测费用</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cooperation">
      <div class="cooperation_img">
        <div class="one_img">
          <img src="../../assets/image/advantage/Carrepair.png" />
        </div>
        <div class="two_img">
          <div class="two_img_explain">
            <span class="Two_img_ch">检车家</span>
            <span class="Two_img_eng">About us</span>
            <div class="Two_img_details">
              <div>检车家是一家独立第三方车辆检测机构，提供二手车检测、陪买、淘车等服务，拥有专业的二手车检测师团队，服务范围覆盖北京、上海、广州、深圳等全国500多个城市。检车家以客观、专业、中立为服务理念，以打造第三方最公正的二手车评估平台为服务目标，致力于创造更透明的市场交易环境，打造二手车诚信体系，让广大客户可以放心买车，买到放心车。</div>
              <div>检车家自2016年成立以来，已经帮助用户规避了1万余辆事故车、水泡车、火烧车和调表车等问题车。经过自身的努力和市场的考验，检车家成长为二手车检测行业中的佼佼者，拥有100多万用户，在同行业中处于领先地位，并于2019年成功当选为中国汽车流通协会理事单位、会员单位。</div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="cooperation_Partner w">
          <div class="Partner_title">合作伙伴</div>
          <div class="Partner_img">
            <img src="../../assets/image/service/Steering .png" />
            <span class="Partner_china">partners</span>
            <img src="../../assets/image/service/Steering .png" />
          </div>
          <div class="Partner_rotation">
            <div class="arrow_left" @click="prevImg">
              <i class="iconfont iconzuojiantou"></i>
            </div>
            <div class="arrow_center">
              <div
                class="arrow_center_float"
                :style="{ width: calculation + 'px', left: position_left + 'px' }"
              >
                <div class="arrow_center_img" v-for="(item, index) in galleryList" :key="index">
                  <div class="box_img">
                    <img :src="item.url" alt />
                  </div>
                </div>
              </div>
            </div>
            <div class="arrow_right" @click="nextImg">
              <i class="iconfont icondibudaohanglan-"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title :visible.sync="dialogVisible" width="15%">
      <div class="qrcode">
        <img src="../../assets/image/account_img.jpg" alt />
      </div>
      <div class="qrcode_title">手机扫码关注检车家公众号 获取详情</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      offsetCount: 0,
      position_left: 0,
      calculation: 0,
      galleryList: [],
       dialogVisible: false
    };
  },
  created() {
    this.getData();
  },

  methods: {
    async getData() {
      const { data: res } = await this.$ajax.get(
        "/v1/website/friendly-link-partner?type=" + 1
      );
      if (res.code == 0) {
        this.galleryList = res.data;
        console.log(res.data.length);
        this.calculation = res.data.length * 212;
      }
    },
    // 左箭头
    prevImg() {
      if (this.position_left == 0) {
        return;
      } else {
        this.offsetCount--;
        this.position_left += 212;
      }
    },
    // 右箭头
    nextImg() {
      let All_left =
        -this.calculation -
        -this.calculation -
        -(this.galleryList.length - 5) * 212;
      if (this.galleryList.length <= 5) {
        return false;
      } else {
        if (this.position_left === -All_left) {
          return false;
        } else {
          this.position_left -= 212;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  .container_service {
    text-align: center;
    margin: 45px 0 0 0;
    .service_title {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(0, 105, 170, 1);
      line-height: 32px;
    }
    .service_Steering {
      span {
        text-transform: uppercase;
        font-size: 46px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
      img {
        width: 40px;
        height: 40px;
        margin: 0 18px;
      }
    }
  }
  .container_Image {
    display: flex;
    justify-content: space-between;

    .waper_left {
      width: 400px;
      height: 380px;
      margin: 60px 0 40px 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .waper_center {
      width: 361px;
      height: 380px;
      margin: 60px 20px 40px 20px;
      display: flex;
      justify-content: space-between;
      .waper_Vehicle {
        position: relative;
        .left {
          margin-right: 21px;
        }
        .Vehicle {
          position: absolute;
          top: 210px;
          left: 68px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
        img {
          width: 170px;
          height: 100%;
        }
      }
      .waper_Scouringcar {
        position: relative;
        .Scouringcar {
          position: absolute;
          top: 207px;
          left: 67px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    .waper_right {
      width: 400px;
      height: 380px;
      margin: 60px 0 40px 0;
      .waper_Accompany {
        position: relative;
        .Accompany {
          position: absolute;
          top: 106px;
          left: 180px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
      }
      img {
        width: 100%;
        height: 170px;
      }
      .waper_right_b {
        display: flex;
        justify-content: space-between;
        .waper_Preparation {
          margin-right: 20px;
          position: relative;
          .Preparation {
            position: absolute;
            top: 134px;
            left: 79px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }
        .waper_Transfer {
          position: relative;
          .Transfer {
            position: absolute;
            top: 131px;
            left: 60px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }
        img {
          margin-top: 20px;
          width: 190px;
          height: 190px;
        }
      }
    }
  }
  .container_advantage {
    height: 560px;
    position: relative;
    .advantage_img {
      height: 326px;
      text-align: center;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        position: relative;
      }
      .advantage_positi {
        position: absolute;
        height: 556px;
        width: 1200px;
        top: 110px;
        left: 50%;
        transform: translate(-50%);
        span {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }

        .our {
          font-size: 46px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          text-transform: uppercase;
        }
      }
      .advantage_details {
        width: 1200px;
        height: 300px;
        margin: 0 auto;
        position: relative;
        .advantage_Five_posiaiton {
          position: absolute;
          top: -55px;
          .advantage_Five {
            width: 1200px;
            height: 300px;
            display: flex;
            margin: 0 auto;
            justify-content: space-between;
            .advantage_major,
            .advantage_objective,
            .advantage_industry,
            .advantage_Intelligence,
            .advantage_Quality {
              width: 224px;
              height: 300px;
              background: rgba(255, 255, 255, 1);
              box-shadow: 0px 0px 20px 0px rgba(0, 167, 234, 0.2);
            }
            img {
              width: 90px;
              height: 86px;
              display: block;
              margin: 40px auto;
            }
            .first_level_title {
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 34px;
            }
            .two_level_title {
              font-size: 19px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(203, 203, 203, 1);
              line-height: 34px;
            }
            .three_level_title {
              margin-top: 11px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
            }
          }
        }
      }
    }
  }
  .cooperation {
    margin-top: 145px;
    margin-bottom: 100px;
    .cooperation_img {
      margin-bottom: 120px;
      display: flex;
      .one_img {
        width: 50%;
        height: 560px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .two_img {
        width: 43%;
        height: 560px;
        background-color: #1a354b;
        border-top-right-radius: 10%;
        border-bottom-right-radius: 10%;
        .two_img_explain {
          width: 570px;
          height: 390px;
          margin: 93px 0 0 34px;
          .Two_img_ch {
            font-size: 46px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
            padding-right: 11px;
          }
          .Two_img_eng {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(0, 105, 170, 1);
            line-height: 32px;
            text-transform: uppercase;
          }
          .Two_img_details {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 30px;
            margin-top: 26px;
          }
        }
      }
    }
    .cooperation_Partner {
      .Partner_title {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(0, 105, 170, 1);
        line-height: 32px;
        text-align: center;
      }
      .Partner_img {
        text-align: center;
        .Partner_china {
          font-size: 46px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          text-transform: uppercase;
          margin: 0 25px;
        }
        img {
          width: 41px;
          height: 41px;
        }
      }
      .Partner_rotation {
        margin-top: 80px;
        width: 1200px;
        height: 160px;
        display: flex;
        .arrow_left {
          width: 15px;
          height: 100%;
          line-height: 160px;
          background-color: #e4e4e4;
        }
        .arrow_center {
          width: 1140px;
          height: 100%;
          margin: 0 15px;
          position: relative;
          overflow: hidden;
          .arrow_center_float {
            position: absolute;
            top: 0;
            height: 100%;
            transition: 0.4s;
            .arrow_center_img {
              width: 201px;
              height: 100%;
              float: left;
              background: rgba(242, 242, 242, 1);
              border: 1px solid rgba(237, 237, 237, 1);
              border-radius: 2px;
              margin-right: 10px;
              .box_img {
                width: 136px;
                height: 112px;
                margin: 24px auto;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
          }
        }
        .arrow_right {
          width: 15px;
          height: 100%;
          line-height: 160px;
          background-color: #e4e4e4;
        }
      }
    }
  }
  .qrcode {
    width: 100%;
    height: 200px;
    margin-bottom: 5px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .qrcode_title {
    width: 100%;
    font-size: 16px;
    text-align: center;
  }
}
</style>
